<section>

  <kendo-grid [data]="languageTranslationGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="languageTranslationGridstate.sort"
              (sortChange)="languageTranslationGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="languageTranslationGridstate.take"
              [skip]="languageTranslationGridstate.skip"
              [columnMenu]="false"
              (pageChange)="languageTranslationGridPageChange($event)"
              (dataStateChange)="languageTranslationDataStateChange($event)"
              [filter]="languageTranslationGridstate.filter"  [loading]="languageTranslationLoading">
    <kendo-grid-column field="languageCode" title="{{languageTranslationLabel.languageCode}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="componentName" title="{{languageTranslationLabel.componentName}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="controlName" title="{{languageTranslationLabel.controlName}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">

      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>

    </kendo-grid-column>
    <kendo-grid-column field="controlText" title="{{languageTranslationLabel.controlText}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>        
        <textarea kendoTextArea class="kendoInput txtAreaSize" [value]="dataItem.controlText"  (blur)="controlNameLeave($event,dataItem)"></textarea>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class=" col-sm-12 center">
    <button (click)="saveControlName()" class="m-3 clearKendoButton btn btn-success" [disabled]="saveInProgress" kendoButton>
      Save <kendo-loader *ngIf="saveInProgress"></kendo-loader>
    </button>
  </div>
</section>
